import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { Icon } from '@monash/portal-react';
import c from './sortable-item.module.scss';

const SortableItem = ({ id, data, conditionalContent, children }) => {
  const {
    attributes,
    listeners,
    setNodeRef,
    setActivatorNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({ id, data });

  const itemStyle = {
    transform: CSS.Translate.toString(transform),
    transition,
    zIndex: isDragging ? 1 : 0,
    cursor: isDragging ? 'grabbing' : 'inherit',
  };

  const handleStyle = {
    cursor: isDragging ? 'grabbing' : 'grab',
  };

  return (
    <div
      ref={setNodeRef}
      className={c.draggable}
      style={itemStyle}
      {...attributes}
    >
      <button
        type="button"
        ref={setActivatorNodeRef}
        style={handleStyle}
        className={c.handle}
        {...listeners}
      >
        <Icon.Drag />
      </button>
      <div>{children}</div>
      <div className={c.conditionalContent}>{conditionalContent}</div>
    </div>
  );
};

export default SortableItem;
